import { IBlockDefinition, IBlockProps } from '@fox/blocks';
import { DROP_PANEL_BLOCK_TYPE } from '../../../form-block-types';
import { RenderBlockComponent } from '../../render-block-component';

//will have to move these to blocks at some point too (along with all the rest)
export type DropPanelProps = {
	padBottom: number;
	columnContents: Array<{
		columnIndex: number;
		items: any[]; //NodeUnion;
	}>;
	columns: Array<{
		width: number;
	}>;
	bodyBackgroundColor?: string;
	backgroundColor?: string;
	width?: number;
	enableViewInBrowserLink?: boolean;
	listStyle?: []; //ListStyleOptions;
};

function DropPanelBlock({ props, id }: IBlockProps<DropPanelProps>) {
	const config = props;
	const columns = config.columns;

	const backgroundColor = config.bodyBackgroundColor ?? 'transparent';

	return columns.map((c, i) => {
		const key = `${id}-${i}`;
		const contents = props.columnContents.find(content => content.columnIndex === i)?.items ?? [];
		return contents.map(content => {
			return (
				<div key={key} style={{ backgroundColor, minHeight: '30px', minWidth: '30px' }}>
					<RenderBlockComponent {...content} />
				</div>
			);
		});
	});
}

export const DropPanelBlockRuntime: IBlockDefinition<DropPanelProps> = {
	type: DROP_PANEL_BLOCK_TYPE,
	Component: DropPanelBlock
};
